import { Card, Flex, Heading, Skeleton, Text } from '@radix-ui/themes'
import { HealthStat } from './types'

export const HealthStats = ({ stats, loading }: { stats: HealthStat[]; loading: boolean }) => {
  return (
    <Flex gap="3" wrap="wrap">
      {stats.map((stat) => (
        <Card key={stat.label}>
          <Flex direction="column" gap="1">
            <Text size="2" color="gray">
              {stat.label}
            </Text>
            <Skeleton loading={loading}>
              <Heading size="6" color={stat.alert ? 'red' : undefined}>
                {stat.value}
              </Heading>
            </Skeleton>
          </Flex>
        </Card>
      ))}
    </Flex>
  )
}
